import { render, staticRenderFns } from "./providers-plain.vue?vue&type=template&id=1f7e0d0c&scoped=true&lang=pug&"
import script from "./providers-plain.vue?vue&type=script&lang=js&"
export * from "./providers-plain.vue?vue&type=script&lang=js&"
import style0 from "./providers-plain.vue?vue&type=style&index=0&id=1f7e0d0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7e0d0c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230921151340/components/widgets/image.vue').default})
